"use client";
import Script from "next/script";

export type FbqCommand = "init" | "track" | "trackCustom";

export const FBQ_ACTIONS = [
	"CompleteRegistration",
	"InitiateCheckout",
	"CustomizeProduct",
	"SubmitApplication",
	"Subscribe",
	"StartTrial",
] as const;
export type FbqAction = (typeof FBQ_ACTIONS)[number];

export type FbqPrimitive = string | number | boolean | undefined;

export type FbqNestedObject = {
	[key: string]:
		| FbqPrimitive
		| FbqPrimitive[]
		| FbqNestedObject
		| FbqNestedObject[];
};

export type FbqParams = FbqNestedObject;

declare global {
	interface Window {
		fbq?: (
			command: FbqCommand,
			action?: FbqAction | string,
			parameters?: FbqParams,
		) => void;
	}
}

export function MetaPixel({ pixelId }: { pixelId?: string }) {
	if (!pixelId) {
		console.warn(
			"Meta Pixel ID is not provided! Skipping Meta Pixel initialization.",
		);
		return null;
	}

	return (
		<>
			{/** biome-ignore lint/nursery/useUniqueElementIds: No need to generate unique ID for this script. */}
			<Script id="meta-pixel-init" strategy="afterInteractive">
				{`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${pixelId}');
          fbq('track', 'PageView');
        `}
			</Script>

			<noscript>
				{/** biome-ignore lint/performance/noImgElement: This <img> doest not render any content. */}
				<img
					alt=""
					width="1"
					height="1"
					style={{ display: "none" }}
					src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`}
				/>
			</noscript>
		</>
	);
}
